import { DateTime } from 'luxon'

const user_separators = [' ', '/', '.', '-'];

let mask_numbers_chars =
[
	'd', 'm', 'y', 'h', 's'
];

mask_numbers_chars = mask_numbers_chars
.concat(mask_numbers_chars.map(c => c.toUpperCase()));

const MASK_CONFIGS =
{
	'french':
	{
		format: 'DD/MM/YYYY',
		luxon_format: 'ddMMyyyy',
		iso_format: 'yyyy-MM-dd',

		humanValueFromIso: iso => iso
		.slice(8, 10) + '/' + iso.slice(5, 7) + '/' + iso.slice(0, 4),

		temperUserInput: function (input, mask)
		{
			if (!input?.value || input.value.length >= mask.length) return;

			const added_char = input.value[input.value.length-1];

			const next_mask_char = mask[input.value.length];

		// le caractère saisi peut séparer les parties de la date (DD/MM par ex.)
			if (user_separators.includes(added_char))
			{
				const prev_user_char = input.value[input.value.length-2];

			// le prochain caractère du masque n'est pas un nombre non plus
			// on estime que l'utilisateur veut saisir 3/ au lieu de 03/ par ex.
				if (prev_user_char && !mask_numbers_chars.includes(next_mask_char))
				{
					const replaced_val = input.value.slice(0, -2) +
						'0' + prev_user_char + added_char;

					input.value = replaced_val;
				}
				else
				{
					const mask_char = mask[input.value.length-2];

				// vu qu'on ajoute automatiquement les caractères spéciaux,
				// on ignore lorsque l'utilisateur entre un caractère qu'on vient
				// d'ajouter
					if (mask_char === added_char && next_mask_char !== added_char)
					{
						input.value = input.value.slice(0, -1);
					}

					return;
				}
			}

		// ajoute des carac. spéciaux selon le masque (slash, tiret, etc)
			for (let i = input.value.length; i < mask.length && mask[i] &&
				!mask_numbers_chars.includes(mask[i]); i++)
			{
				input.value += mask[i];
			}
		},

		parseUserPaste (input, mask)
		{
			return;
		}
	},

	'year':
	{
		format: 'YYYY',
		luxon_format: 'yyyy',
		iso_format: 'yyyy',

		humanValueFromIso: iso => DateTime.fromISO(iso).toFormat('yyyy'),

		parseUserPaste (input, mask)
		{
			return;
		}
	}
};

export default MASK_CONFIGS;